import moment from "moment";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Grid, Modal, Button } from "semantic-ui-react";
import { Can } from "../../modules";

import Service from "./service";

import "./Recalls.scss";

export const RECALL_STATUS = {
  UNSUPPORTED: 1,
  UNSETTLED: 2,
  SETTLED: 3,
};

class Recalls extends Component {
  state = {
    openRdwRecalls: [],
    openDistrimateAndPonRecalls: [],
    previousRecalls: [],
    isModalVisible: false,
  };

  componentDidMount() {
    this.handleGetRecalls();
  }

  normalizeData = (recallsResponse = {}) => {
    const openDistrimateAndPonRecalls = [],
      openRdwRecalls = [],
      previousRecalls = [];

    const { rdw_recalls = [], recalls = [], pon_recalls = [] } = recallsResponse;

    recalls.forEach(({ close_date, campaign_code, campaign_name, status }) => {
      if (status === RECALL_STATUS.UNSETTLED) {
        openDistrimateAndPonRecalls.push({ description: `#${campaign_code} ${campaign_name}`, date: close_date, status });
      } else {
        previousRecalls.push({
          description: `#${campaign_code} ${campaign_name || ""}`,
          date: close_date,
          status: status,
        });
      }
    });

    pon_recalls.forEach(recall => {
      openDistrimateAndPonRecalls.push({
        description: `#${recall.id || ""} ${recall.campaign_name || ""}`,
      });
    });

    rdw_recalls.forEach(({ close_date, campaign_code, campaign_name, status }) => {
      if (status === RECALL_STATUS.UNSETTLED) {
        openRdwRecalls.push({ description: `${campaign_code ? `#${campaign_code}` : ""} ${campaign_name}`, date: close_date, status });
      } else {
        previousRecalls.push({
          description: `${campaign_code ? `#${campaign_code}` : ""} ${campaign_name || ""}`,
          date: close_date,
          status: status,
        });
      }
    });

    this.setState({ openDistrimateAndPonRecalls, openRdwRecalls, previousRecalls });
  };

  handleGetRecalls = async () => {
    const { vin_nr: vin, reg_nr: license_plate } = this.props.car;
    const { id } = this.props.location;

    const DistrimateAndRdwRecallsRequestPayload = {
      dealer_location_id: id,
      ...(vin ? { vin } : {}),
      ...(license_plate ? { license_plate } : {}),
    };

    try {
      const response = await Service.getRecalls(DistrimateAndRdwRecallsRequestPayload);

      if (!response?.data?.data) throw Error("Error fetching recalls");

      this.normalizeData(response.data.data);
    } catch (error) {
      console.error("Error getting distrimate and pon recalls", error);
    }
  };

  handleToggleModal = () => {
    this.setState(({ isModalVisible }) => ({ isModalVisible: !isModalVisible }));
  };

  renderRecallStatus = status => {
    const { t } = this.props;

    switch (status) {
      case RECALL_STATUS.UNSUPPORTED:
        return t("unsupported").message || "Unsupported";
      case RECALL_STATUS.UNSETTLED:
        return t("unsettled").message || "Unsettled";
      case RECALL_STATUS.SETTLED:
        return t("settled").message || "Settled";
      default:
        return "";
    }
  };

  renderRecallItem = recall => (
    <Grid.Row className="Recalls__content-item">
      <Grid.Column width={12}>{recall.description}</Grid.Column>
      <Grid.Column width={2}>{this.renderRecallStatus(recall.status)}</Grid.Column>
      <Grid.Column width={2}>{recall.date && moment(recall.date).format("DD-MM-YYYY")}</Grid.Column>
    </Grid.Row>
  );

  renderRecallsHeader = (title, showColumns) => {
    const { t } = this.props;

    return (
      <Grid.Row>
        <Grid.Column width={12} className="Recalls__content-title">
          {title}
        </Grid.Column>
        {showColumns && (
          <>
            <Grid.Column width={2} className="Recalls__content-title">
              {t("status").message || "Status"}
            </Grid.Column>
            <Grid.Column width={2} className="Recalls__content-title">
              {t("close_Date").message || "Close Date"}
            </Grid.Column>
          </>
        )}
      </Grid.Row>
    );
  };

  renderOpenDistrimateAndPonRecalls = () => {
    const { t } = this.props;
    const { openDistrimateAndPonRecalls, openRdwRecalls } = this.state;

    if (!openDistrimateAndPonRecalls?.length) return null;

    const showColumns = !openRdwRecalls?.length;

    return (
      <>
        {this.renderRecallsHeader(t("open_factory_recalls").message || "Open Factory Recalls", showColumns)}

        {openDistrimateAndPonRecalls.map(recall => this.renderRecallItem(recall))}
      </>
    );
  };

  renderPreviousRecalls = () => {
    const { t } = this.props;
    const { previousRecalls, openDistrimateAndPonRecalls, openRdwRecalls } = this.state;

    if (!previousRecalls.length) return null;

    const showColumns = !openDistrimateAndPonRecalls?.length && !openRdwRecalls?.length;

    return (
      <>
        {this.renderRecallsHeader(t("previous_recalls").message || "Previous Recalls", showColumns)}

        {previousRecalls.map(recall => this.renderRecallItem(recall))}
      </>
    );
  };

  renderRdwRecalls = () => {
    const { t } = this.props;
    const { openRdwRecalls } = this.state;

    if (!openRdwRecalls.length) return null;

    return (
      <>
        {this.renderRecallsHeader(t("open_rdw_recalls").message || "Open RDW Recalls", true)}

        {openRdwRecalls.map(recall => this.renderRecallItem(recall))}
      </>
    );
  };

  renderModalContent = () => {
    const { t } = this.props;
    const { openDistrimateAndPonRecalls, openRdwRecalls, previousRecalls } = this.state;

    if (!openDistrimateAndPonRecalls?.length && !openRdwRecalls?.length && !previousRecalls?.length)
      return <Grid.Row className="Recalls__content-no-data">{t("no_recalls_found").message || "No Recalls Found"}</Grid.Row>;

    return (
      <Grid>
        {this.renderRdwRecalls()}

        {this.renderOpenDistrimateAndPonRecalls()}

        {this.renderPreviousRecalls()}
      </Grid>
    );
  };

  renderModalListOfRecalls() {
    const { isModalVisible } = this.state;
    const { t } = this.props;

    if (!isModalVisible) return null;

    return (
      <Modal className="Recalls" closeOnEscape open={isModalVisible} onClose={this.handleToggleModal} closeOnDimmerClick={false}>
        <Modal.Header>
          <div className="Recalls__header">
            {t("recalls").message || "Recalls"}
            <div className="Recalls__header-actions">
              <Button color="green" onClick={this.handleToggleModal}>
                {t("close").message || "Close"}
              </Button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling className="Recalls__content">
          {this.renderModalContent()}
        </Modal.Content>
      </Modal>
    );
  }

  render() {
    const { t } = this.props;
    const { openRdwRecalls, openDistrimateAndPonRecalls, previousRecalls } = this.state;
    if (!openRdwRecalls?.length && !openDistrimateAndPonRecalls.length && !previousRecalls.length) return null;

    const hasOpenRecalls = !!openRdwRecalls.length || !!openDistrimateAndPonRecalls.length;

    return (
      <Can I="list" the="recalls" or={["pon-recall"]}>
        <Button basic fluid size="large" className={`recall-button ${hasOpenRecalls ? "-red-border" : ""}`} onClick={this.handleToggleModal}>
          {t("recalls").message || "Recalls"}
        </Button>
        {this.renderModalListOfRecalls()}
      </Can>
    );
  }
}

export default withTranslation()(Recalls);
